import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLockClosed20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconLockClosed20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13 6v1.5H7V6a3 3 0 0 1 6 0M5.5 7.5V6a4.5 4.5 0 0 1 9 0v1.5A2.5 2.5 0 0 1 17 10v6.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 16.5V10a2.5 2.5 0 0 1 2.5-2.5m9 1.5h-9a1 1 0 0 0-1 1v6.5a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1m-3.25 4.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLockClosed20);
